export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_7.9eb01c8a.jpg";